import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import Pusher, { Channel } from 'pusher-js';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class PusherService {

  private pusher: Pusher | null = null;
  private channels: Map<string, Channel> = new Map();

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  private init() {
    if (this.pusher || !isPlatformBrowser(this.platformId)) {
      return;
    }

    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster
    });
  }

  getSocketId(): string | null {
    this.init();
    return this.pusher ? this.pusher.connection.socket_id : null;
  }

  subscribe(channelName: string): Channel | null {
    this.init();

    if (!this.pusher) {
      return null;
    }

    if (!this.channels.has(channelName)) {
      this.channels.set(channelName, this.pusher.subscribe(channelName));
    }

    return this.channels.get(channelName) as Channel;
  }

  unsubscribe(channelName: string) {
    if (!this.pusher || !this.channels.has(channelName)) {
      return;
    }

    this.pusher.unsubscribe(channelName);
    this.channels.delete(channelName);
  }
}
